export const EligibilityGetstartedContents = {
  labels: {
    greeting: (name?: string) => (name ? `Hi ${name},` : "Hi,"),
    initiateEligibility: "You are 1 step away to check your eligibility"
  },
  buttons: {
    getStarted: "GET STARTED"
  }
};
